import { STARTUP_TRACK } from "@/data/content";
import Reveal from "@/components/Reveal";
import { Trophy, ArrowRight, Users } from "lucide-react";

export default function StartupTrack() {
  return (
    <section id="startup-track" className="py-24 sm:py-32 px-5 sm:px-8 lg:px-12 bg-paper">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-crimson font-semibold mb-5">{STARTUP_TRACK.eyebrow}</p>
          <h2 className="font-heading text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tighter leading-[0.92] max-w-4xl">
            {STARTUP_TRACK.heading}
          </h2>
          <p className="mt-6 text-xl text-ink/70 max-w-3xl leading-relaxed">{STARTUP_TRACK.subhead}</p>
        </Reveal>

        {/* Prize callout with glowing border */}
        <Reveal delay={0.08}>
          <div className="relative mt-14 p-[2px] overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-crimson via-crimson/40 to-crimson animate-border-glow" />
            <div className="relative bg-ink text-white p-8 sm:p-12 flex flex-col sm:flex-row items-start gap-6">
              <Trophy size={48} className="text-crimson shrink-0" strokeWidth={1.5} />
              <div>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-crimson font-semibold mb-2">Cash Prize for Winners</p>
                <p className="font-heading text-xl sm:text-2xl font-medium leading-snug">{STARTUP_TRACK.prizeCallout}</p>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-12 grid lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
          {STARTUP_TRACK.sessions.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08}>
              <div className="group bg-paper hover:bg-white p-8 h-full transition-colors flex flex-col">
                <span className="font-mono text-5xl font-bold text-ink/10 group-hover:text-crimson transition-colors">{s.num}</span>
                <h3 className="font-heading text-2xl font-semibold tracking-tight mt-5">{s.title}</h3>
                <p className="mt-3 text-ink/65 text-[15px] leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-col sm:flex-row sm:items-center justify-between gap-6 border border-ink/10 bg-white p-8">
            <div className="flex items-start gap-4 max-w-2xl">
              <Users size={24} className="text-crimson shrink-0 mt-1" />
              <p className="text-ink/75 leading-relaxed">{STARTUP_TRACK.whoItsFor}</p>
            </div>
            <button
              onClick={() => document.querySelector("#register")?.scrollIntoView({ behavior: "smooth" })}
              data-testid="startup-track-cta"
              className="shrink-0 bg-crimson text-white font-semibold px-7 py-4 flex items-center justify-center gap-2 hover:bg-ink transition-colors group"
            >
              Enter the Track <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
